var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellcarconfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 666,
    height: 474,
    viewBox: "0 0 666 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_1134)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.61 147.01C488.47 126.32 548.91 153.21 569.6 207.08C590.29 260.94 563.4 321.38 509.53 342.07C455.67 362.76 395.23 335.87 374.54 282C353.85 228.14 380.74 167.7 434.61 147.01ZM446.91 179.03C483.09 165.13 523.69 183.2 537.59 219.38C551.49 255.56 533.42 296.16 497.24 310.06C461.06 323.96 420.46 305.89 406.56 269.71C392.66 233.53 410.73 192.93 446.91 179.03Z",
    fill: "#9DD9E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.16 134.8L440.89 124.92C443.84 123.79 447.17 125.27 448.31 128.22L457.16 151.27C458.29 154.22 456.81 157.55 453.86 158.69L428.13 168.57C425.18 169.7 421.85 168.22 420.71 165.27L411.86 142.22C410.73 139.27 412.21 135.94 415.16 134.8Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.43 126.7L534.61 137.9C537.49 139.18 538.8 142.59 537.52 145.48L527.48 168.04C526.2 170.92 522.79 172.23 519.9 170.95L494.72 159.75C491.84 158.47 490.53 155.06 491.81 152.17L501.85 129.62C503.13 126.74 506.54 125.43 509.43 126.71V126.7Z",
    fill: "#85CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.81 187.63L591.69 213.36C592.82 216.31 591.34 219.64 588.39 220.77L565.34 229.62C562.39 230.75 559.06 229.27 557.92 226.32L548.04 200.59C546.91 197.64 548.39 194.31 551.34 193.17L574.39 184.32C577.34 183.19 580.67 184.67 581.81 187.62V187.63Z",
    fill: "#85CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M589.92 281.89L578.72 307.07C577.44 309.95 574.03 311.26 571.14 309.98L548.59 299.94C545.71 298.66 544.4 295.25 545.68 292.36L556.88 267.18C558.16 264.3 561.57 262.99 564.46 264.27L587.01 274.31C589.89 275.59 591.2 279 589.92 281.89Z",
    fill: "#85CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528.99 354.28L503.26 364.16C500.31 365.29 496.98 363.81 495.84 360.86L486.99 337.81C485.86 334.86 487.34 331.53 490.29 330.39L516.02 320.51C518.97 319.38 522.3 320.86 523.44 323.81L532.29 346.86C533.42 349.81 531.94 353.14 528.99 354.28Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.72 362.38L409.54 351.18C406.66 349.9 405.35 346.49 406.63 343.6L416.67 321.05C417.95 318.17 421.36 316.86 424.25 318.14L449.43 329.34C452.31 330.62 453.62 334.03 452.34 336.92L442.3 359.47C441.02 362.35 437.61 363.66 434.72 362.38Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.34 301.45L352.46 275.73C351.33 272.78 352.81 269.45 355.76 268.31L378.81 259.46C381.76 258.33 385.09 259.81 386.23 262.76L396.11 288.49C397.24 291.44 395.76 294.77 392.81 295.91L369.76 304.76C366.81 305.89 363.48 304.41 362.34 301.46V301.45Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.24 207.19L365.44 182.01C366.72 179.13 370.13 177.82 373.02 179.1L395.57 189.14C398.45 190.42 399.76 193.83 398.48 196.72L387.28 221.9C386 224.78 382.59 226.09 379.7 224.81L357.15 214.77C354.27 213.49 352.96 210.08 354.24 207.19Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.5 70.57C188.36 53.84 234.23 72.6 250.95 112.45C267.68 152.31 248.92 198.18 209.07 214.9C169.21 231.63 123.34 212.87 106.62 173.01C89.8904 133.15 108.65 87.28 148.5 70.56V70.57ZM158.44 94.27C185.21 83.04 216.02 95.63 227.26 122.4C238.49 149.17 225.9 179.98 199.13 191.22C172.36 202.45 141.55 189.86 130.31 163.09C119.08 136.32 131.67 105.51 158.44 94.27Z",
    fill: "#9DD9E3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.66 61.88L152.7 53.89C154.88 52.98 157.41 54.01 158.33 56.19L165.49 73.24C166.41 75.42 165.37 77.95 163.19 78.87L144.15 86.86C141.97 87.77 139.44 86.74 138.52 84.56L131.36 67.51C130.45 65.33 131.48 62.8 133.66 61.88Z",
    fill: "#85CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.06 53.65L223.17 61.46C225.36 62.35 226.42 64.88 225.52 67.07L218.52 84.19C217.63 86.38 215.1 87.44 212.91 86.54L193.8 78.73C191.61 77.84 190.55 75.31 191.45 73.12L198.45 56C199.34 53.81 201.87 52.75 204.06 53.65Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.65 97.61L267.64 116.65C268.56 118.83 267.52 121.36 265.34 122.28L248.29 129.44C246.11 130.35 243.58 129.32 242.66 127.14L234.67 108.1C233.75 105.92 234.79 103.39 236.97 102.47L254.02 95.31C256.2 94.39 258.73 95.43 259.65 97.61Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.87 168.01L260.06 187.12C259.17 189.31 256.64 190.37 254.45 189.47L237.33 182.47C235.14 181.58 234.08 179.05 234.98 176.86L242.79 157.75C243.68 155.56 246.21 154.5 248.4 155.4L265.52 162.4C267.71 163.29 268.77 165.82 267.87 168.01Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.91 223.61L204.87 231.6C202.69 232.52 200.16 231.48 199.24 229.3L192.08 212.25C191.17 210.07 192.2 207.54 194.38 206.62L213.42 198.63C215.6 197.71 218.13 198.75 219.05 200.93L226.21 217.98C227.13 220.16 226.09 222.69 223.91 223.61Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.52 231.83L134.41 224.02C132.22 223.13 131.16 220.6 132.06 218.41L139.06 201.29C139.95 199.1 142.48 198.04 144.67 198.94L163.78 206.75C165.97 207.64 167.03 210.17 166.13 212.36L159.13 229.48C158.24 231.67 155.71 232.73 153.52 231.83Z",
    fill: "#CDE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9198 187.87L89.9298 168.83C89.0198 166.65 90.0498 164.12 92.2298 163.2L109.28 156.04C111.46 155.12 113.99 156.16 114.91 158.34L122.9 177.38C123.81 179.56 122.78 182.09 120.6 183.01L103.55 190.17C101.37 191.09 98.8398 190.05 97.9198 187.87Z",
    fill: "#85CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6997 117.47L97.5097 98.36C98.3997 96.17 100.93 95.11 103.12 96.01L120.24 103.01C122.43 103.9 123.49 106.43 122.59 108.62L114.78 127.73C113.89 129.92 111.36 130.98 109.17 130.08L92.0497 123.08C89.8597 122.19 88.7997 119.66 89.6997 117.47Z",
    fill: "#85CBD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.72 23.02H475.23C480.07 23.02 484.02 26.97 484.02 31.81V427.33C484.02 432.17 480.07 436.12 475.23 436.12H190.72C185.88 436.12 181.93 432.17 181.93 427.33V31.81C181.93 26.97 185.88 23.02 190.72 23.02Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.72 31.26H475.23V426.78H190.72V31.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.39 14.89H381.57C383.25 14.89 384.63 16.27 384.63 17.95V42.88C384.63 44.56 383.25 45.94 381.57 45.94H284.39C282.71 45.94 281.33 44.56 281.33 42.88V17.95C281.33 16.27 282.71 14.89 284.39 14.89Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.97 0C341.19 0 347.86 6.67 347.86 14.89C347.86 23.11 341.19 29.78 332.97 29.78C324.75 29.78 318.08 23.11 318.08 14.89C318.08 6.67 324.75 0 332.97 0Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.83 89.8H332.83C334.12 89.8 335.17 90.85 335.17 92.14C335.17 93.43 334.12 94.48 332.83 94.48H222.83C221.54 94.48 220.49 93.43 220.49 92.14C220.49 90.85 221.54 89.8 222.83 89.8Z",
    fill: "#BDBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.83 102.54H298.79C300.08 102.54 301.13 103.59 301.13 104.88C301.13 106.17 300.08 107.22 298.79 107.22H222.83C221.54 107.22 220.49 106.17 220.49 104.88C220.49 103.59 221.54 102.54 222.83 102.54Z",
    fill: "#BDBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.83 153.27H288.52C289.81 153.27 290.86 154.32 290.86 155.61C290.86 156.9 289.81 157.95 288.52 157.95H222.83C221.54 157.95 220.49 156.9 220.49 155.61C220.49 154.32 221.54 153.27 222.83 153.27Z",
    fill: "#BDBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.83 166H298.79C300.08 166 301.13 167.05 301.13 168.34C301.13 169.63 300.08 170.68 298.79 170.68H222.83C221.54 170.68 220.49 169.63 220.49 168.34C220.49 167.05 221.54 166 222.83 166Z",
    fill: "#BDBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.92 153.27H365.61C366.9 153.27 367.95 154.32 367.95 155.61C367.95 156.9 366.9 157.95 365.61 157.95H299.92C298.63 157.95 297.58 156.9 297.58 155.61C297.58 154.32 298.63 153.27 299.92 153.27Z",
    fill: "#BDBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.83 216.73H288.52C289.81 216.73 290.86 217.78 290.86 219.07C290.86 220.36 289.81 221.41 288.52 221.41H222.83C221.54 221.41 220.49 220.36 220.49 219.07C220.49 217.78 221.54 216.73 222.83 216.73Z",
    fill: "#BDBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.83 229.47H271.67C272.96 229.47 274.01 230.52 274.01 231.81C274.01 233.1 272.96 234.15 271.67 234.15H222.83C221.54 234.15 220.49 233.1 220.49 231.81C220.49 230.52 221.54 229.47 222.83 229.47Z",
    fill: "#BDBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.92 216.73H349.48C350.77 216.73 351.82 217.78 351.82 219.07C351.82 220.36 350.77 221.41 349.48 221.41H299.92C298.63 221.41 297.58 220.36 297.58 219.07C297.58 217.78 298.63 216.73 299.92 216.73Z",
    fill: "#BDBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.07 229.47H332.91C334.2 229.47 335.25 230.52 335.25 231.81C335.25 233.1 334.2 234.15 332.91 234.15H283.07C281.78 234.15 280.73 233.1 280.73 231.81C280.73 230.52 281.78 229.47 283.07 229.47Z",
    fill: "#BDBFC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.85 103.12L436.09 88.79C437.01 87.86 438.51 87.86 439.44 88.79C440.37 89.71 440.37 91.21 439.44 92.14L423.42 108.26L423.35 108.32C422.38 109.19 420.89 109.11 420.01 108.15L414.69 102.28C413.81 101.31 413.89 99.81 414.86 98.94C415.83 98.07 417.33 98.14 418.2 99.11L421.84 103.13L421.85 103.12Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.35 80.17H441.88C443.85 80.17 445.46 81.78 445.46 83.75V113.28C445.46 115.25 443.85 116.86 441.88 116.86H412.35C410.38 116.86 408.77 115.25 408.77 113.28V83.75C408.77 81.78 410.38 80.17 412.35 80.17Z",
    stroke: "#BDBFC4",
    strokeWidth: 3.48,
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.85 166.59L436.09 152.26C437.01 151.33 438.51 151.33 439.44 152.26C440.37 153.18 440.37 154.68 439.44 155.61L423.42 171.73L423.35 171.79C422.38 172.66 420.89 172.58 420.01 171.62L414.69 165.75C413.81 164.78 413.89 163.28 414.86 162.41C415.83 161.54 417.33 161.61 418.2 162.58L421.84 166.6L421.85 166.59Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.35 143.63H441.88C443.85 143.63 445.46 145.24 445.46 147.21V176.74C445.46 178.71 443.85 180.32 441.88 180.32H412.35C410.38 180.32 408.77 178.71 408.77 176.74V147.21C408.77 145.24 410.38 143.63 412.35 143.63Z",
    stroke: "#BDBFC4",
    strokeWidth: 3.48,
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.85 230.05L436.09 215.72C437.01 214.79 438.51 214.79 439.44 215.72C440.37 216.64 440.37 218.14 439.44 219.07L423.42 235.19L423.35 235.25C422.38 236.12 420.89 236.04 420.01 235.08L414.69 229.21C413.81 228.24 413.89 226.74 414.86 225.87C415.83 225 417.33 225.07 418.2 226.04L421.84 230.06L421.85 230.05Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.35 207.1H441.88C443.85 207.1 445.46 208.71 445.46 210.68V240.21C445.46 242.18 443.85 243.79 441.88 243.79H412.35C410.38 243.79 408.77 242.18 408.77 240.21V210.68C408.77 208.71 410.38 207.1 412.35 207.1Z",
    stroke: "#BDBFC4",
    strokeWidth: 3.48,
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44 169.42C180.98 169.42 196.87 176.53 208.37 188.03C219.87 199.53 226.98 215.41 226.98 232.96C226.98 245.41 223.38 257.03 217.17 266.86C211.14 276.4 202.63 284.22 192.56 289.43L182.4 313.39C181.22 316.2 177.98 317.52 175.17 316.33C174.33 315.98 173.63 315.44 173.09 314.79L155.73 296.02C140.31 294.15 126.58 286.73 116.59 275.82C106.23 264.51 99.9102 249.46 99.9102 232.95C99.9102 215.41 107.02 199.52 118.52 188.02C130.02 176.52 145.9 169.41 163.45 169.41L163.44 169.42Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.69 307.65L186.72 284.01L189.12 282.77C197.99 278.19 205.5 271.29 210.84 262.85C216.52 253.88 219.49 243.57 219.49 232.96C219.49 218.04 213.62 203.88 203.08 193.33C192.53 182.78 178.37 176.92 163.45 176.92C148.53 176.92 134.37 182.79 123.82 193.33C113.27 203.88 107.41 218.04 107.41 232.96C107.41 247.02 112.63 260.4 122.12 270.77C131.15 280.63 143.35 286.97 156.64 288.59L159.37 288.92L176.7 307.65H176.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.08 239.07L222.01 171.73C226.66 167.05 234.23 167.03 238.91 171.68C243.59 176.33 243.61 183.9 238.96 188.57L163.16 264.83C163.02 264.97 162.88 265.1 162.73 265.22C162.72 265.23 162.71 265.24 162.69 265.25C157.81 269.66 150.25 269.29 145.83 264.41L120.63 236.6C116.21 231.72 116.59 224.15 121.47 219.73C126.35 215.32 133.91 215.7 138.33 220.57L155.08 239.05V239.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.39 232.3C123.35 230.04 123.52 226.55 125.78 224.51C128.04 222.47 131.53 222.64 133.57 224.9L154.86 248.4L226.56 176.26C228.71 174.1 232.21 174.09 234.37 176.24C236.53 178.39 236.54 181.89 234.39 184.05L158.59 260.31L158.38 260.5C156.12 262.54 152.63 262.37 150.59 260.11L125.39 232.3Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3498 365.26L66.6898 384.61C61.6898 389.27 60.5698 392.38 61.8098 399.08L68.2898 434.24L109.76 436.02H220.87L447.85 432.45L576.97 418.63C584.76 413.33 590.48 405.49 593.51 396.45C593.93 387.22 597.52 379.48 596.89 369.6C596.54 364.14 592.22 357.56 591.71 350.81C590.81 338.93 589.76 337.58 584.74 326.98L576.36 319.76L546.98 290.77C548.45 289.87 550.24 288.94 552.46 287.99C557.96 285.63 549.07 283.99 545.4 283.17C535.58 280.99 518.82 278.87 510.92 279.08L509.99 278.79C439.47 264.92 359.47 255.54 290.34 282.54C263.08 293.18 212.25 320.67 192.99 330.93C162.65 335.23 91.0798 341.15 72.3398 365.26H72.3498Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.34 282.16C258.73 294.67 224.05 314.38 192.99 330.93L200.83 330.82C168.02 335.36 100.56 348 84.25 361.45L72.65 364.86C66.89 372.47 66.25 375.38 66.68 384.61L76.88 378.3L84.62 362.79C101.54 347.86 185.4 334.05 211.43 330.57C238.5 313.48 266.99 296.1 296.57 283.58C298.66 282.7 298.41 282.65 295.56 282.47L291.34 282.15V282.16Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.68 339.03C309.68 331.34 397.94 326.36 488.19 321.84C493.38 321.36 536.19 311.75 525.2 305.54C521.19 303.92 517.17 302.39 513.14 300.92C468.7 284.82 422.93 278 376.3 277.16C328.23 277.1 284.66 290.65 245.85 318.63C236.08 323.45 228.02 330.23 221.69 339.02L221.68 339.03Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.69 327.57C416.95 325.49 452.41 323.63 488.19 321.84L500.12 319.76L500.45 296.66C464.12 285.24 426.82 279.17 388.98 277.55C388.17 277.64 387.16 278.08 386.96 279.64C386.61 282.32 381.69 327.57 381.69 327.57Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.68 339.03C265.93 335.16 310.25 331.98 354.85 329.2C354.85 329.2 365.67 284.83 366.62 280.87C367.32 277.91 365.54 277.47 364.59 277.44C321.13 279.43 281.48 292.96 245.84 318.65C236.07 323.47 228.01 330.25 221.68 339.04V339.03Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.35 320.47L546.3 290.11L546.05 290.03C538.8 291.64 540.16 297 544.23 301.56C553.21 311.66 557.99 315.7 577.36 320.46L577.35 320.47Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216 440.42H232.11C233.11 440.42 250.25 432.65 252.26 431.58H223.05C221.01 431.58 220.37 429.02 220.28 427.43C218.19 390.91 197.1 371.24 160.25 370.31H159.8C121.68 371.26 103.13 391.6 101.61 429.17C101.61 429.17 101.9 432.05 99.6797 432C97.4497 431.95 76.9597 431.9 67.0897 430.3C65.9697 430.75 62.9697 431.85 62.7097 433.1C62.4097 434.52 63.3697 436.94 66.2997 437.58C73.0797 439.06 87.5897 439.52 98.8197 440.65C106.6 441.43 109.68 441.53 109.74 439.18C109.77 438.01 110.51 437.21 110.53 435.82C144.88 435.96 179.16 435.95 213.52 435.81C213.52 436.93 213.7 438.05 213.76 439.18C213.83 440.5 214.53 440.43 216 440.43V440.42Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.51 396.46L597.78 397.44C599.08 397.74 600.56 398.66 600.48 400.26C598.93 429.79 588.66 428.06 563.11 430.7L565.48 414.8C567.94 414.21 579.11 412.18 580.51 410.89C581.58 409.92 583.71 407.71 585.25 404.41C587.49 400.42 588.68 397.76 590.67 396.59C591.62 396.04 592.44 396.2 593.5 396.44L593.51 396.46Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.64 324.6C259.78 302.47 284.35 290 308.21 282.79C332.05 275.58 355.18 273.62 378.44 272.5C418.65 272.5 455.5 279.1 494.03 290.21H494.04C495.95 290.79 497.55 291.65 498.77 292.74C500 293.85 500.84 295.2 501.2 296.75L501.22 296.84V296.95L500.41 319.29C505.42 328.01 505.41 359.74 493.97 361.73C456.62 368.22 440.31 396.77 438.94 432.63L437.38 432.58C438.78 395.96 455.6 366.81 493.71 360.19C503.51 358.49 503.81 327.93 498.96 319.91L499.65 297.01C499.35 295.82 498.69 294.77 497.72 293.9C496.68 292.96 495.27 292.21 493.59 291.7C456.26 280.93 417.61 273.6 378.63 274.05L370.76 328.37L370.74 328.51L370.68 328.63C361.59 345.83 366.4 401.23 366.84 422.4C366.89 424.99 366.71 426.83 366.28 428.1L364.64 428C365.01 426.9 365.32 424.84 365.27 422.43C364.82 400.04 359.89 346.85 369.23 328.03L377.03 274.14C354.37 275.27 331.84 277.28 308.65 284.3C284.97 291.46 260.59 303.83 234.64 325.8L233.63 324.6H233.64ZM224.44 338.62C207.96 358.44 223.27 406.64 228.13 431.58H226.1C221.08 405.84 205.71 358.04 222.92 337.36L224.44 338.62Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.94 429.18C566.43 391.61 546.69 369.19 508.56 368.23H508.11C466.81 369.28 447.07 393.62 448.17 433.7L552.56 435.79L567.93 429.18H567.94Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3301 405.49C70.6001 405.49 78.7001 404.71 84.8001 406C92.2001 407.56 96.6801 411.44 86.0801 414.04C81.3501 415.2 73.7701 416.42 71.6101 417.01C71.6101 417.01 69.7201 417.36 68.9801 416.22C68.0801 414.84 65.1101 405.51 67.3301 405.49Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.1 355.86C116.52 356.34 116.73 358.64 115.04 361.67C110.87 369.12 95.2099 380.98 72.6699 380.92C74.6699 367.53 78.4099 360.38 114.1 355.86Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.37 317.37C244.44 314.75 247.57 314.53 252.17 314.22C266.27 313.27 266.49 334.49 254.25 336.86L238.52 337.91C232.59 338.31 229.16 322.64 239.37 317.37Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.07 316.78C241.66 315.44 243.77 314.71 245.81 314.28C247.84 313.85 249.8 313.71 252.12 313.56C256.91 313.24 260.21 315.33 262.04 318.42C262.94 319.93 263.49 321.68 263.68 323.49C263.87 325.29 263.72 327.16 263.23 328.92C262.09 333.03 259.11 336.6 254.37 337.51H254.33L254.29 337.52L238.56 338.57C237.07 338.67 235.74 337.94 234.68 336.67C233.67 335.46 232.91 333.76 232.51 331.83C232.11 329.92 232.07 327.78 232.48 325.69C233.18 322.17 235.2 318.77 239.06 316.78H239.07ZM246.09 315.57C244.15 315.98 242.16 316.67 239.68 317.95C236.23 319.73 234.43 322.78 233.79 325.94C233.41 327.85 233.45 329.81 233.81 331.55C234.17 333.27 234.83 334.77 235.7 335.81C236.49 336.76 237.45 337.3 238.48 337.24L254.17 336.19C258.33 335.37 260.96 332.2 261.97 328.55C262.42 326.95 262.55 325.25 262.38 323.61C262.21 321.98 261.72 320.42 260.92 319.08C259.32 316.4 256.44 314.58 252.22 314.86C249.95 315.01 248.04 315.15 246.09 315.56V315.57Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.38 327.3C250.9 326.69 255.56 326.5 260.12 326.56C261.38 326.58 261.99 324.3 259.69 324.26C258.27 324.24 246.22 324.35 245.29 325.25C244.46 326.05 244.32 327.58 246.38 327.3Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.75 342.57C328.75 342.57 324.82 343.31 323.5 345.02C322.18 346.74 326.26 347.15 332.83 346.81C339.4 346.47 349.17 345.24 350.98 345.19C352.8 345.14 356.72 344.16 357.26 342.64C357.8 341.12 354.71 340.33 351.22 340.33C347.73 340.33 339.54 340.87 328.74 342.56L328.75 342.57Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.79 384.62C533.25 384.62 553.08 404.45 553.08 428.91C553.08 453.37 533.25 473.2 508.79 473.2C484.33 473.2 464.5 453.37 464.5 428.91C464.5 404.45 484.33 384.62 508.79 384.62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.6 384.62C185.06 384.62 204.89 404.45 204.89 428.91C204.89 453.37 185.06 473.2 160.6 473.2C136.14 473.2 116.31 453.37 116.31 428.91C116.31 404.45 136.14 384.62 160.6 384.62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.6 399.12C177.05 399.12 190.39 412.46 190.39 428.91C190.39 445.36 177.05 458.7 160.6 458.7C144.15 458.7 130.81 445.36 130.81 428.91C130.81 412.46 144.15 399.12 160.6 399.12Z",
    fill: "#D5D7DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.63 424.96C162.81 424.96 164.58 426.73 164.58 428.91C164.58 431.09 162.81 432.86 160.63 432.86C158.45 432.86 156.68 431.09 156.68 428.91C156.68 426.73 158.45 424.96 160.63 424.96Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.79 399.12C525.24 399.12 538.58 412.46 538.58 428.91C538.58 445.36 525.24 458.7 508.79 458.7C492.34 458.7 479 445.36 479 428.91C479 412.46 492.34 399.12 508.79 399.12Z",
    fill: "#D5D7DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.83 424.96C511.01 424.96 512.78 426.73 512.78 428.91C512.78 431.09 511.01 432.86 508.83 432.86C506.65 432.86 504.88 431.09 504.88 428.91C504.88 426.73 506.65 424.96 508.83 424.96Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.99 331.83C461.99 331.83 458.06 332.57 456.74 334.28C455.42 336 459.5 336.41 466.07 336.07C472.65 335.73 482.41 334.5 484.22 334.45C486.04 334.4 489.96 333.42 490.5 331.9C491.04 330.38 487.95 329.59 484.46 329.59C480.97 329.59 472.78 330.13 461.98 331.82L461.99 331.83Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.71 350.82C591.17 350.33 506.64 308.56 584.74 326.99C588.41 329.44 589.56 334.19 592.38 340C594.02 343.37 592.22 349.28 591.71 350.82Z",
    fill: "#11353B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4198 364.29L89.1198 364C92.1498 367.96 78.1998 367.57 78.4698 371.44C78.4698 371.44 79.5798 371.79 79.2898 373.02C78.9998 374.25 77.2998 377.23 77.2998 377.23C77.2998 377.23 88.6598 374.45 89.2998 373.39C99.9098 355.82 86.2898 362.35 86.4198 364.29Z",
    fill: "#D6DDE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.7395 375.96C89.4695 375.91 92.9295 375.14 95.2595 372.65C95.7895 372.08 96.9295 367.81 97.3195 367.12C98.8195 364.48 99.4895 366.97 99.2095 368.01C97.9995 372.45 96.4795 377.13 89.7395 375.96Z",
    fill: "#D6DDE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.11 362.13C96.4296 365.44 100.91 363.96 101.5 365.67C102.26 367.92 96.7796 373.41 104.49 369.47C106.49 368.45 111.09 361.73 111.95 359.83C111.96 359.8 109.32 359.39 107.55 361.94C106.87 362.91 105.63 364.73 104.49 366.39C104.39 365.31 104.25 364.08 104.02 363.21C103.81 362.42 103.52 361.93 103.12 362.13H103.11Z",
    fill: "#D6DDE7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.89 430.37C247.52 431.46 248.57 431.47 231.31 440.42L348.24 440.91H455.03C455.41 440.91 455.71 440.6 455.73 440.22L456.09 428.36C456.1 427.98 455.41 427.67 455.03 427.67C449.07 427.67 444.78 428.75 438.81 429.38C432.24 428.34 426.82 427.22 419.99 427.22C369.29 427.82 317.43 427.51 266.89 430.37Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.7 433.68L257.53 437.12C265.69 433.56 270.96 433.49 284.7 432.82C298.48 432.15 407.14 429.06 413.7 433.67V433.68Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.66 333.95L586.23 338.84C585.58 337.17 584.37 333.05 580.58 330.62C579.23 329.75 586.97 329.89 588.51 341.21C588.9 344.09 588.28 344.62 587.29 342.02H587.27C578.23 340.07 561.47 332.33 567.65 333.95H567.66Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.6 384.62C185.06 384.62 204.89 404.45 204.89 428.91C204.89 429.38 204.89 429.85 204.87 430.32C204.12 406.52 184.59 387.45 160.61 387.45C136.63 387.45 117.09 406.52 116.35 430.32C116.33 429.85 116.33 429.38 116.33 428.91C116.33 404.45 136.16 384.62 160.62 384.62H160.6Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.79 384.62C533.25 384.62 553.08 404.45 553.08 428.91C553.08 429.38 553.08 429.85 553.06 430.32C552.31 406.52 532.78 387.45 508.8 387.45C484.82 387.45 465.28 406.52 464.54 430.32C464.53 429.85 464.52 429.38 464.52 428.91C464.52 404.45 484.35 384.62 508.81 384.62H508.79Z",
    fill: "#295860"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.85 417.41C153.11 413.22 153.35 409.29 154.52 405.19C154.91 403.84 159.98 403.68 161.24 403.75C161.66 403.78 166.85 403.98 165.98 405C163.38 408.08 161.46 411.62 160.53 415.54C159.75 418.81 154.56 421 153.85 417.4V417.41Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.16 417.22C170.42 414.48 173.93 412.71 178.06 411.66C179.42 411.31 182.11 415.62 182.68 416.76C182.87 417.13 185.3 421.73 183.98 421.49C180.01 420.79 175.99 420.92 172.12 422.08C168.9 423.05 164.4 419.65 167.16 417.23V417.22Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.99 428.68C178 430.12 181.29 432.27 184.27 435.32C185.25 436.32 182.88 440.82 182.19 441.88C181.96 442.23 179.21 446.65 178.75 445.39C177.37 441.6 175.24 438.18 172.3 435.42C169.85 433.12 170.52 427.52 174 428.69L173.99 428.68Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.52 440.34C168.29 444.53 168.08 448.46 166.94 452.57C166.56 453.92 161.49 454.13 160.23 454.06C159.81 454.04 154.62 453.88 155.48 452.85C158.06 449.75 159.94 446.19 160.85 442.25C161.61 438.97 166.78 436.74 167.52 440.34Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.2 440.59C150.97 443.36 147.47 445.16 143.34 446.24C141.98 446.6 139.26 442.31 138.68 441.18C138.49 440.81 136.02 436.23 137.34 436.46C141.31 437.13 145.34 436.97 149.19 435.78C152.4 434.79 156.93 438.14 154.19 440.59H154.2Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.28 429.19C143.26 427.78 139.95 425.66 136.95 422.64C135.96 421.64 138.29 417.13 138.98 416.06C139.21 415.71 141.92 411.27 142.39 412.53C143.8 416.31 145.96 419.71 148.92 422.45C151.39 424.73 150.77 430.34 147.28 429.2V429.19Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.07 417.41C501.33 413.22 501.57 409.29 502.74 405.19C503.13 403.84 508.2 403.68 509.46 403.75C509.88 403.78 515.07 403.98 514.2 405C511.6 408.07 509.68 411.62 508.75 415.54C507.97 418.81 502.78 421 502.07 417.4V417.41Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.39 417.22C518.65 414.47 522.16 412.71 526.29 411.66C527.65 411.32 530.34 415.62 530.91 416.76C531.1 417.13 533.53 421.73 532.21 421.49C528.24 420.79 524.22 420.92 520.35 422.08C517.13 423.05 512.63 419.65 515.39 417.23V417.22Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.21 428.68C526.22 430.12 529.51 432.27 532.49 435.32C533.47 436.32 531.1 440.82 530.41 441.88C530.18 442.23 527.43 446.65 526.97 445.39C525.59 441.6 523.46 438.18 520.52 435.42C518.07 433.12 518.74 427.52 522.22 428.69L522.21 428.68Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.739 440.34C516.509 444.53 516.299 448.46 515.159 452.57C514.779 453.92 509.71 454.13 508.45 454.06C508.03 454.04 502.84 453.88 503.7 452.85C506.28 449.75 508.16 446.19 509.07 442.25C509.83 438.97 514.999 436.74 515.739 440.34Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M502.42 440.59C499.19 443.36 495.69 445.16 491.56 446.24C490.2 446.6 487.48 442.31 486.9 441.18C486.71 440.81 484.24 436.24 485.56 436.46C489.53 437.13 493.56 436.97 497.41 435.78C500.62 434.79 505.15 438.14 502.41 440.59H502.42Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M495.5 429.19C491.48 427.78 488.17 425.66 485.17 422.64C484.18 421.64 486.51 417.13 487.2 416.06C487.43 415.71 490.14 411.27 490.61 412.52C492.02 416.3 494.18 419.7 497.14 422.44C499.61 424.72 498.99 430.33 495.5 429.19Z",
    fill: "#102550"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27 473.79H663.68C664.93 473.79 665.95 472.77 665.95 471.53C665.95 470.28 664.93 469.27 663.68 469.27H2.27C1.02 469.27 0 470.29 0 471.53C0 472.78 1.02 473.79 2.27 473.79Z",
    fill: "#102550"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_1134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 665.95,
    height: 473.79,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellcarconfirm);
export default __webpack_public_path__ + "static/media/sellcarconfirm.88c9eaa413cc3214b2876134824e9620.svg";
export { ForwardRef as ReactComponent };